import Menu from "../../../components/menu/menu.jsx";

function ListaNFSe(){
    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu />
                </div>

                <div className="col py-6 me-3">
                    <div className="d-flex justify-content-between">
                        <h3>Lista NFSe</h3>
                    </div>
                    <br></br>
                </div>
            </div>
        </div>
    </>
};

export default ListaNFSe;
